// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3V0nU","error":"Textarea_error__30vg1","readonly":"Textarea_readonly__2CvdR","disabled":"Textarea_disabled__3HBDG"};